import React from 'react';
import { MapPin, MessageCircle, Mail, Clock, Instagram } from 'lucide-react';
import { useTranslation } from '../i18n';
export function Footer() {
  const {
    t
  } = useTranslation();
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-27">
          {/* Location */}
          <div className="space-y-4" data-id="element-28">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-29">
              {t('footer.location')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-30">
              <MapPin className="w-5 h-5 text-teal-500 mt-1 shrink-0" data-id="element-31" />
              <div data-id="element-32">
                <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors" data-id="element-33">
                  <p className="text-gray-300" data-id="element-34">{t('footer.address')}</p>
                  <p className="text-gray-400" data-id="element-35">Angel, Islington</p>
                </a>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-id="element-36">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-37">
              {t('footer.contact')}
            </h3>
            <div className="space-y-3" data-id="element-38">
              <a href="https://wa.me/447345197820" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-39">
                <MessageCircle className="w-5 h-5 text-teal-500" data-id="element-40" />
                <span data-id="element-41">{t('footer.whatsappChat')}</span>
              </a>
              <a href="mailto:infodenticodentalclinic@gmail.com" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-42">
                <Mail className="w-5 h-5 text-teal-500" data-id="element-43" />
                <span data-id="element-44">infodenticodentalclinic@gmail.com</span>
              </a>
              <a href="http://instagram.com/dentico_clinic" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-45">
                <Instagram className="w-5 h-5 text-teal-500" data-id="element-46" />
                <span data-id="element-47">@dentico_clinic</span>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4" data-id="element-48">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-49">
              {t('footer.hours')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-50">
              <Clock className="w-5 h-5 text-teal-500 mt-1 shrink-0" data-id="element-51" />
              <div className="space-y-2 text-sm w-full" data-id="element-52">
                <div className="flex justify-between gap-4" data-id="element-53">
                  <span className="text-gray-400" data-id="element-54">{t('footer.monFri')}</span>
                  <span className="text-white" data-id="element-55">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-56">
                  <span className="text-gray-400" data-id="element-57">{t('footer.saturday')}</span>
                  <span className="text-white" data-id="element-58">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-59">
                  <span className="text-gray-400" data-id="element-60">{t('footer.sunday')}</span>
                  <span className="text-white" data-id="element-61">{t('footer.closed')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-500" data-id="element-62">
          <p data-id="element-63">
            &copy; {new Date().getFullYear()} Dentico Clinic.{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}